import React, { Component } from 'react';
import { SofaItemImage, SofaItemOverview, SofaQuantity } from '@sofology/sofologycomponents';

import './ReadonlyItemBundle.scss';

import { BasketItemModel } from 'models/Basket';
import { formatCurrency } from 'formatters';
import { BasketSofashield } from 'components';

interface OwnProps {
    checkoutItem: BasketItemModel;
}

//  Any changes made here should be synced to BasketItemBundle.tsx / ReadonlyItem.tsx / BasketItem.tsx
class ReadonlyItemBundle extends Component<OwnProps> {
    render(): JSX.Element {
        const { checkoutItem } = this.props;

        return (
            <div className='readonly-item-bundle'>
                <div className='readonly-item-bundle__header'>
                    <div>{(checkoutItem.range ?? 'undefined') + ' bundle'} <div> in {checkoutItem.swatchColour}, {this.getBundleItemsCount()} items</div></div>
                </div>
                {this.renderBasketContent()}
                <div className='readonly-item-bundle__footer'>
                    <div>Bundle total</div>
                    <div className='readonly-item-bundle__price'>
                        <div className='readonly-item-bundle__price__now'>
                            {formatCurrency(checkoutItem.totalPrice.value, 0)}
                        </div>
                        <div className='readonly-item-bundle__price__savings'>
                            <div className='readonly-item-bundle__price__was'>
                                was <span>{formatCurrency(checkoutItem.totalPrice.value + checkoutItem.savingsPrice.value, 0)}</span>
                            </div>
                            <div className='readonly-item-bundle__price__save'>
                                save {formatCurrency(checkoutItem.savingsPrice.value, 0)}
                            </div>
                        </div>
                    </div>
                </div>
                {
                    checkoutItem.sofashieldQuantity > 0
                    && <BasketSofashield
                        linkedSku={checkoutItem.product.code}
                        range={checkoutItem.range?.toLowerCase() ?? ''}
                        optionsQuantity={checkoutItem.quantity}
                        sofashieldQuantity={checkoutItem.sofashieldQuantity}
                        loading={false} />
                }
            </div>
        );
    }

    renderBasketContent(): JSX.Element {
        const { checkoutItem } = this.props;

        return (
            <div className='readonly-item-bundle__content'>
                {checkoutItem.product.productReferences.map(productReference =>
                    <div className='readonly-item-bundle__item' key={productReference.target.code}>
                        <SofaItemImage product={productReference.target} enableSofaLink={false} variant='small' />
                        <div className='readonly-item-bundle__item__details'>
                            <SofaItemOverview product={productReference.target} enableSofaLink={false} disableTitle={true} variant='small' />
                            <div className='readonly-item-bundle__item__controls'>
                                <SofaQuantity value={checkoutItem.quantity} hideControls={true} disabled={true} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    getBundleItemsCount = (): number => {
        return this.props.checkoutItem.product.productReferences
            .map(product => product.quantity)
            .reduce((sum, productQuantity) => sum + productQuantity);
    };
}

export default ReadonlyItemBundle;